module.exports = __webpack_public_path__ + "static/media/user.10fdbe36.svg";